
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class SleepNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Sleep';
        this.id = 'node_sleep';
        this.requirements = [['WM2000', 'WM2000EV', 'WS1102']];
        this.linkedFeature = 'wifiwm2000';

        this.inputs = [
            {
                name: 'Sleep for',
                portId: 'sleep_for',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'DAYS',
                name: 'Days',
                settingType: SettingType.NUMBER,
                required: true,
                default: '0',
            },
            {
                id: 'MINUTES',
                name: 'Minutes',
                settingType: SettingType.NUMBER,
                required: true,
                default: '0',
            },
            {
                id: 'SECONDS',
                name: 'Seconds',
                settingType: SettingType.NUMBER,
                required: true,
                default: 60,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDependencies() {
        return ['datetime'];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const DAYS = this.getSettingValue('DAYS');
        const MINUTES = this.getSettingValue('MINUTES');
        const SECONDS = this.getSettingValue('SECONDS');

        const links = project.getNodeLinks(this, 'sleep_for');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    dim wake_day,wake_minute as word
    dim wake_second as byte
    dim current_time as dword = datetime_current_timestamp()
    current_time = current_time + (${DAYS} * 86400) + (${MINUTES} * 60) + ${SECONDS}
    datetime_from_timestamp(current_time, wake_day, wake_minute, wake_second)
    sys.sleep(wake_day,wake_minute,wake_second)`,
            });
        }

        return blocks;
    }
}
